<template>
  <div class="flex items-center justify-center">
    <div class="white-logo-container">
      <img class="logo" src="/logo/artfield-logo-black.png" alt="Logo dark">
    </div>
    <div class="arrow-container">
      <Popover :isOpen="isPopoverOpen" :disabled="isPopoverDisabled" @update:isOpen="updatePopoverState">
        <template #trigger>
          <img class="logo" src="/icons/arrow_down_black.png" alt="Logo dark">
        </template>
        <ul class="popover-menu">
          <li v-if="user.admin"><a href="/dashboard">Dashboard</a></li>
          <li><a href="/field/profile/settings"> Settings<img src="/icons/topright.png"/></a></li>
          <li><a href="/terms-and-conditions"> Legal Terms <img src="/icons/topright.png"/></a></li>
          <li><a href="/about?q=contact"> Contact <img src="/icons/topright.png"/></a></li>
          <li @click="signOut">Log out</li>
        </ul>
      </Popover>
    </div>

  </div>
</template>

<style scoped lang="scss">
.logo {
  width: 100%;
}
.popover-menu {
  padding-top: 20px;
}
.arrow-container {

  display: flex;
  flex-direction: column;
}
.arrow-container img {
  width: 24px;
}
.white-logo-container {
  width: 40px;
  height: 40px;
  background: $admin-white;
  border-radius: 50%;
  border: 1px solid #b8b8b8;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 2px;
  margin-left: 24px;
}
</style>
<script setup lang="ts">
import Popover from "~/components/Popover.vue";

import {useUserStore} from "~/composables/useUserStore";
import {useRouter} from "vue-router";
const router = useRouter();
const {user, logOut} = useUserStore();

const isPopoverOpen = ref(false);
const isPopoverDisabled = ref(false);

const signOut = () => {
  logOut();
  router.push('/')
}
const updatePopoverState = (newState: any) => {
  isPopoverOpen.value = newState;
};

</script>